/* Project Import will be here */
import { updateFavouriteProduct } from "services/products";
import { getErrorObject, successToast, getSuccessObject, errorToast } from "../utilities/utils";
import { types as productTypes } from "./products";
import { types as productDetailsTypes } from "./product/productDetails";
import { types as recommendedTypes } from "./recommended";
import { types as hotDealsTypes } from "./hotDeals";
import { types as similarProductsTypes } from "./similarProducts";
import smartListConstants from "./smartList/smartListConstant";
import { types as exchangeOrderProductsConstants } from "./exchange/exchangeOrderProducts";
import { IFavoriteProductParams } from "../models/productModels";
import { showMsgFromJson } from "reducers/common";
import Constants from "../utilities/appConstants";
import { GAAddToWishlist, GARemoveFromWishlist } from "hooks/googleAnalyticsHooks";
import { appRoutesConst } from "app/navigation";
import { push } from "connected-react-router";
/* Project Import will be here */

export const types = {
    UPDATE_FAVOURITE_PRODUCT_REQUEST: "product/UpdateFavouriteProductRequest",
    UPDATE_FAVOURITE_PRODUCT_SUCCESS: "product/UpdateFavouriteProductSuccess",
    UPDATE_FAVOURITE_PRODUCT_FAILURE: "product/UpdateFavouriteProductFailure"
};

let initialState = {
    isLoading: false,
    data: {},
    error: null
};

export const favProduct = (state = initialState, action) => {
    switch (action.type) {
        case types.UPDATE_FAVOURITE_PRODUCT_REQUEST:
            return { ...state, isLoading: true };
        case types.UPDATE_FAVOURITE_PRODUCT_SUCCESS:
            return { ...state, error: null, isLoading: false };
        case types.UPDATE_FAVOURITE_PRODUCT_FAILURE:
            return { ...state, isLoading: false, error: action.payload.error };
        default:
            return state;
    }
};

export const updateFavProductStatus = (productInfo, callback) => {
    return async (dispatch, getState) => {
        dispatch({ type: types.UPDATE_FAVOURITE_PRODUCT_REQUEST });

        try {
            const data: IFavoriteProductParams = [{
                PrincipalId: productInfo.PrincipalId,
                DistributorId: productInfo.DistributorId,
                IsFavourite: productInfo.IsFavourite === 0 ? 1 : 0,
                ProductId: productInfo.ProductId
            }];

            const response = await updateFavouriteProduct(data);

            /* GA - Track add to fav and remove from fav events */
            if (window.isEnableGA) {
                if (productInfo.IsFavourite === 0)
                    GAAddToWishlist(productInfo);
                else
                    GARemoveFromWishlist(productInfo);
            }

            /* Extract the error message and error code from the response object */
            const { message, successCode } = getSuccessObject(response);
            /* If success code is exist show the success code message or show the api response message returned by the API request */
            if (successCode !== "")
                dispatch(showMsgFromJson(`common.alerts.success.${successCode}`, Constants.SUCCESS));
            else
                successToast({ content: message });

            /* Reload the product list if it is the FavProduct page */
            let pathname = getState().router.location.pathname;
            if (pathname === appRoutesConst.favProducts) {
                dispatch(push(appRoutesConst.favProducts));
            }

            dispatch({
                type: types.UPDATE_FAVOURITE_PRODUCT_SUCCESS
            });

            /* Update the isFavourite property against the product */
            dispatch({
                type: productTypes.PRODUCT_UPDATE_IS_FAV,
                payload: productInfo
            });
            dispatch({
                type: recommendedTypes.RECOMMENDED_UPDATE_IS_FAV,
                payload: productInfo
            });
            dispatch({
                type: productDetailsTypes.PRODUCT_DERAILS_UPDATE_IS_FAV,
                payload: productInfo
            });
            dispatch({
                type: hotDealsTypes.HOT_DEALS_UPDATE_IS_FAV,
                payload: productInfo
            });
            dispatch({
                type: similarProductsTypes.SIMILAR_PRODUCT_UPDATE_IS_FAV,
                payload: productInfo
            });
            dispatch({
                type: smartListConstants.SMART_LIST_PRODUCT_UPDATE_IS_FAV,
                payload: productInfo
            });
            dispatch({
                type: exchangeOrderProductsConstants.EXCHANGE_ORDER_PRODUCTS_UPDATE_IS_FAV,
                payload: productInfo
            });

            /* Call the callback function */
            if (callback !== undefined)
                callback();
        }
        catch (error) {
            /* Extract the error message and error code from the response object */
            const { message, errorCode } = getErrorObject(error);

            dispatch({
                type: types.UPDATE_FAVOURITE_PRODUCT_FAILURE,
                payload: { error: message }
            });

            /* If error code is exist show the error code message or show the error message returned by the API request */
            if (errorCode !== "")
                dispatch(showMsgFromJson(`common.alerts.error.${errorCode}`, Constants.ERROR));
            else
                errorToast({ content: message });
        }
    };
};